const getLeaguesAndSeasons = (configs) => {
  const __seasons = []
  const __leagues = []
  console.log('configs', configs)
      configs.forEach((x) => {
        if (x.key === 'leagues') {
          Object.keys(x.value).forEach((key) => {
            const league = x.value[key]
            if (league.state === 'published') {
              __leagues.push({
                key: key,
                value: league,
              })
            }
          })
        } else if (x.key === 'seasons') {
          Object.keys(x.value).forEach((key) => {
            const season = x.value[key]
            __seasons.push({
              key: season.key,
              value: season,
            })
          })
        }
      })
  return {
    leagues: __leagues,
    seasons: __seasons,
  }
}

export { getLeaguesAndSeasons }